import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import withTimer from 'HOC/withTimer/withTimer';
import styles from './Timer.module.css';

const TITLE = {
  'add-ons': 'ADD-ONS WILL CLOSE IN',
  edit: 'THIS SALE WILL CLOSE IN',
};

const Timer = ({ timer, version }) => (
  <div className={styles.container}>
    <p className={styles.text}>{get(TITLE, version)}</p>
    <ul className={styles.timer}>
      <li className={styles.item}>
        <h5>{timer.days}</h5>
        <p>Days</p>
      </li>
      <li className={styles.separator}>:</li>
      <li className={styles.item}>
        <h5>{timer.hours}</h5>
        <p>Hrs</p>
      </li>
      <li className={styles.separator}>:</li>
      <li className={styles.item}>
        <h5>{timer.minutes}</h5>
        <p>Min</p>
      </li>
      <li className={styles.separator}>:</li>
      <li className={styles.item}>
        <h5>{timer.seconds}</h5>
        <p>Sec</p>
      </li>
    </ul>
  </div>
);

Timer.propTypes = {
  timer: PropTypes.shape({
    days: PropTypes.string,
    hours: PropTypes.string,
    minutes: PropTypes.string,
    seconds: PropTypes.string,
  }),
  version: PropTypes.string.isRequired,
};

Timer.defaultProps = {
  timer: {
    days: '0',
    hours: '0',
    minutes: '0',
    seconds: '0',
  },
};

export default withTimer(Timer);
